const EventEmitter = {
    _events: {},
    dispatch: function (event, data) {
        if (!this._events[event]) return;
        this._events[event].forEach(callback => callback(data))
    },
    subscribe: function (event, callback) {
        console.log(this._events);
        if (!this._events[event]) this._events[event] = [];
        this._events[event].push(callback);
    },
    unsubscribe(event) {
        if (!this._events[event]) return;
        delete this._events[event];
    }
}
export { EventEmitter };